<span class="player-stats-text">{{ playerStatsData.statsText || seasonStatisticsMessage() }}</span>

@if (statistics()?.isLoading) {
    <div class="skeleton-stats"></div>
} @else {
    @if (!isEpcotEnabled) {
        <div class="player-stats-value-container">
            <span class="player-stats-value" [msValueSlider]="playerStatsData.statsValue.toString()"></span>
        </div>
    } @else {
        @if (isSeasonStatisticsEnabled && (statistics()?.isError || !seasonStatistics())) {
            <span>--</span>
        } @else {
            <div class="player-stats-value-container" [ngClass]="statsIndicator">
                <span class="player-stats-value">{{ seasonStatistics() ?? playerStatsData.statsValue }}</span>
            </div>
        }
    }
}
